import { gql } from "@apollo/client";

export const changeStatus = gql`
  mutation changeTaskEngagementItemStatus($id: ID!, $leadId: ID!, $status: String!, $messageId: ID, $config: Mixed) {
    changeTaskEngagementItemStatus(id: $id, lead_id: $leadId, status: $status, message_id: $messageId, config: $config)
  }
`;